import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class DropdownService {
	private activeDropdownSource = new Subject<string>();
	activeDropdown$ = this.activeDropdownSource.asObservable();

	setActiveDropdown(id: string): void {
		this.activeDropdownSource.next(id);
	}

	clearActiveDropdown(): void {
		this.activeDropdownSource.next(null);
	}
}
